module.exports = __webpack_public_path__ + "6c4a49b258c82a71ef2e0344faa2e6cf.svg";